import { render, staticRenderFns } from "./AppErrorModal.vue?vue&type=template&id=200a06bf&"
import script from "./AppErrorModal.vue?vue&type=script&lang=js&"
export * from "./AppErrorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports